import React from "react";
import { Typography } from "antd";

type BlockedUserNameProps = {
  name?: React.ReactNode;
  locked?: boolean;
};

const BlockedUserName = React.memo(({ name, locked }: BlockedUserNameProps) => {
  return (
    <Typography.Text type={locked ? "secondary" : undefined} style={{ fontSize: "inherit" }}>
      {name}
    </Typography.Text>
  );
});

export default BlockedUserName;
